"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeveloperInviteStore = void 0;
const _ = require("lodash");
const DeveloperInviteBank_1 = require("../banks/DeveloperInviteBank");
class DeveloperInviteStore extends DeveloperInviteBank_1.DeveloperInviteBank {
    getOrgInvites(orgId) {
        return _.values(this.models).filter((inviteModel) => inviteModel.org_id == orgId);
    }
    getDeveloperInvites(devId) {
        return _.values(this.models).filter((inviteModel) => inviteModel.user_id == devId);
    }
}
exports.DeveloperInviteStore = DeveloperInviteStore;
